var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransportation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Offer Icon / transportation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41B32",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E0C1D",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offer-Icon-/-transportation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8637456,10.2791443 L18.7603215,4.15531703 C18.4588623,3.79367719 17.8320792,3.5 17.3612322,3.5 L1.21428571,3.5 C0.543775286,3.5 -2.0783375e-12,4.04377529 -2.0783375e-12,4.71428571 L-2.0783375e-12,15.6428571 C-2.0783375e-12,16.3133676 0.543775286,16.8571429 1.21428571,16.8571429 L2.42857143,16.8571429 C2.42857143,18.8690447 4.05952672,20.5 6.07142857,20.5 C8.08333043,20.5 9.71428571,18.8690447 9.71428571,16.8571429 L14.5714286,16.8571429 C14.5714286,18.8690447 16.2023839,20.5 18.2142857,20.5 C20.2261876,20.5 21.8571429,18.8690447 21.8571429,16.8571429 L23.0714286,16.8571429 C23.741939,16.8571429 24.2857143,16.3133676 24.2857143,15.6428571 L24.2857143,11.4452188 C24.2857143,11.0190996 24.1361891,10.6066175 23.8637456,10.2791443 Z M2.42857143,9.57142857 L2.42857143,5.92857143 L6.07142857,5.92857143 L6.07142857,9.57142857 L2.42857143,9.57142857 Z M6.07142857,18.6785714 C5.06547764,18.6785714 4.25,17.8630938 4.25,16.8571429 C4.25,15.8511919 5.06547764,15.0357143 6.07142857,15.0357143 C7.0773795,15.0357143 7.89285714,15.8511919 7.89285714,16.8571429 C7.89285714,17.8630938 7.0773795,18.6785714 6.07142857,18.6785714 Z M12.1428571,9.57142857 L8.5,9.57142857 L8.5,5.92857143 L12.1428571,5.92857143 L12.1428571,9.57142857 Z M18.2142857,18.6785714 C17.2083348,18.6785714 16.3928571,17.8630938 16.3928571,16.8571429 C16.3928571,15.8511919 17.2083348,15.0357143 18.2142857,15.0357143 C19.2202366,15.0357143 20.0357143,15.8511919 20.0357143,16.8571429 C20.0357143,17.8630938 19.2202366,18.6785714 18.2142857,18.6785714 Z M14.5714286,9.57142857 L14.5714286,5.92857143 L17.076634,5.92857143 L20.1123483,9.57142857 L14.5714286,9.57142857 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportation);
export default __webpack_public_path__ + "static/media/transportation.7f6fbc7ea466d3473a45e521a65f5e06.svg";
export { ForwardRef as ReactComponent };